/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { OralExamCloseTimeSlotRequest } from './oralExamCloseTimeSlotRequest';

export type CloseOralExamCohortBody = OralExamCloseTimeSlotRequest | null;
